import { initStore } from './store'
import { isDev } from '../environment'

export const store = initStore({ withLogger: isDev() })

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppStore = ReturnType<typeof initStore>
